import React, { Component } from 'react'
import { MDBContainer, MDBBtn, MDBModal, MDBModalBody, MDBModalHeader, MDBModalFooter, MDBAlert, MDBSelect , MDBInput, MDBIcon, MDBFormInline  } from 'mdbreact';
import { MDBSelectInput, MDBSelectOptions, MDBSelectOption } from "mdbreact";
import Axios from 'axios'
import { Alert, Form, Input, Button, Select, Icon, message, Tag, Badge, Tooltip  } from 'antd';
import Swal from 'sweetalert2'
import { URL,api } from '../api';
import ban from '../img/math.png'

export default class Modalregistersm extends Component {
    constructor(props) {
        super(props);
                this.state = {
                modal: false,

                send_id :'1', //ผู้ลงทะเบียน
                send_typesm : '', //ประเภท
                name_presentsm : '', //ผู้นำเสนอ
                name_articlesm : '', //ชื่อบทความ
                major_precentsm : 'คณิตศาสตร์', //สาขาที่นำเสนอ
                send_uploadeword1sm : null,
                send_uploadepdf1sm : null,
              //  send_uploadeword12 : null,
             //   send_uploadepdf12 : null,
                send_date1sm : '', //  วันที่ส่ง
                send_statuspaysm : '', //สถานะ ชำระเงิน
                stapatsm : '0',   //สถานะส่ง

                iduser:'',
                radio: '0',
                articletype:[],
                }

                this.handleChange1 = this.handleChange1.bind(this);
                this.handleChange2 = this.handleChange2.bind(this);
             //   this.handleChange3 = this.handleChange3.bind(this);
             //   this.handleChange4 = this.handleChange4.bind(this);
                this.handleSubmit = this.handleSubmit.bind(this);


                this.handleChangetype = this.handleChangetype.bind(this);
                this.toggle = this.toggle.bind(this);
                this.handleChangemajor = this.handleChangemajor.bind(this);
                this.handleChangenamepresent = this.handleChangenamepresent.bind(this);
                this.handleChangesend_name = this.handleChangesend_name.bind(this);
                this.onClickradio = this.onClickradio.bind(this);
                this.gettype = this.gettype.bind(this);
}



toggle = () => {
  this.setState({
    modal: !this.state.modal
  });
 // this.props.selectatf();
 this.gettype();
 if (localStorage.getItem('register_typemamber') === '1' || localStorage.getItem('register_typemamber') === '2') {
  this.setState({ send_statuspaysm: '2'})
 }
}



gettype() {
    setTimeout(() => {
           
      api.get('registercon/selecttpresentationtype')
       .then(res => {
         console.log(res);
       //  this.setState({ bankname: res.data, loading: false })
         this.setState({ articletype: res.data})
       }) 
     }, 0);
 }


onClickradio = (nr) => () => {
  this.setState({
    radio: nr,
  });
};

 componentDidMount() {
       const { iduser } = this.props.iduser
    //   console.log(id_send);
       this.setState({ iduser:this.props.iduser})
    //   setTimeout(() => {
    //     //ภายใน
    //      Axios.get('https://conference.kpru.ac.th/PHPAPI/selectExpert.php')
    //     .then(res => {
    //       console.log(res);
    //     //  this.setState({ bankname: res.data, loading: false })
    //       this.setState({ Expert: res.data})
    //     }) 

    //   }, 0);

  }

//   getExpert() {
//     setTimeout(() => {
//       //ภายใน
//        Axios.get('https://conference.kpru.ac.th/PHPAPI/selectExpert.php')
//       .then(res => {
//         console.log(res);
//       //  this.setState({ bankname: res.data, loading: false })
//         this.setState({ Expert: res.data})
//       }) 
//     }, 0);

// }



  //ปากเปล่าโปสเตอร์
  handleChangetype(event) {    this.setState({send_typesm: event.target.value});  }
  //ปากเปล่าโปสเตอร์สาขา
  handleChangemajor(event) {    this.setState({major_precentsm: event.target.value});  }
  //ผู้นำเสนอ
  handleChangenamepresent(event) {    this.setState({name_presentsm: event.target.value});  }
//ผู้นำเสนอ
  handleChangesend_name(event) {    this.setState({name_articlesm: event.target.value});  }


  handleChange1(event) {    this.setState({send_uploadeword1sm: event.target.files[0]});  }
  handleChange2(event) {    this.setState({send_uploadepdf1sm: event.target.files[0]});  }
 // handleChange3(event) {    this.setState({send_uploadeword12: event.target.files[0]});  }
 // handleChange4(event) {    this.setState({send_uploadepdf12: event.target.files[0]});  }




 handleSubmit= (e) => {
  e.preventDefault();
    // alert('A name was submitted: ' + this.state.value);
   setTimeout(() => {

    const date = new Date();
    const [month, day, year]  = [String(date.getMonth() + 1).padStart(2, '0'), String(date.getDate()).padStart(2, '0'), date.getFullYear()];
    const dates = day+"-"+month+"-"+year ;

      const datafrm = new FormData(); //สร้างฟอร์มสำหรับการส่งข้อมูล
      datafrm.append("send_id", this.props.iduser);
      datafrm.append("send_typesm", this.state.send_typesm);
      datafrm.append("name_presentsm", this.state.name_presentsm);
      datafrm.append("name_articlesm", this.state.name_articlesm);
      datafrm.append("external_typesm", localStorage.getItem('register_typemamber'));
      datafrm.append("major_precentsm", this.state.major_precentsm);
      datafrm.append("send_uploadeword1sm", this.state.send_uploadeword1sm);
      datafrm.append("send_uploadepdf1sm", this.state.send_uploadepdf1sm);
      datafrm.append("agree_typesm", this.state.radio);
    //  datafrm.append("send_uploadeword12", this.state.send_uploadeword12);
    //  datafrm.append("send_uploadepdf12", this.state.send_uploadepdf12);
      datafrm.append("send_date1sm", dates);
      datafrm.append("send_statuspaysm", this.state.send_statuspaysm);
    //  datafrm.append("stapat", this.state.stapat);

    api.post("registercon/InsertArticlesmconn",datafrm,{
    headers: {
        'content-type': 'multipart/form-data'
    }
   })

   .then(res => {
    console.warn(res);
     console.log("response: ", res)
     if (res.data.length !== 0) {
      // this.showitem = true;
       console.log(res)
       console.log(res.data.length) 
    }else{
     // window.location.href = '/'
    }


    if (res.data = '200') {
     // message.success("อัพโหลไฟล์สำเร็จ")
    //  this.setState({ id_send: ""})
     // window.location.href = '/adminfaculty'
     Swal.fire({
      title: 'เพิ่มบทความสำเร็จ',
      text: "Add success articles",
      icon: 'success',
      showCancelButton: false,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'ตกลง'
    }).then((result) => {
      if (result.isConfirmed) {
        // Swal.fire(
        //   'Deleted!',
        //   'Your file has been deleted.',
        //   'success'
        // )
        this.props.list();
        this.toggle()
      }
    })
    
    }else{
      message.error("อัพโหลไฟล์ไม่สำเร็จ!")
    }

  })



}, 2000);

//window.location.href = '/adminfaculty'
//this.props.updateat();
//this.getExpert()

  }

  

  

    render() {
        
        //   console.log(this.state.send_type)
        //   console.log(this.state.major_precent)
        //   console.log(this.state.name_present)
        //   console.log(this.state.send_name)
        //   console.log(this.state.send_uploadeword1)
        //   console.log(this.state.send_uploadepdf1)
        //   console.log(this.state.radio)

        const items = this.state.articletype.map((articletype, i) => (
            <option  value={articletype.presentype_id	} >{articletype.presentype_name}</option>
          ));


        return (
          
            <MDBContainer className='text-left'>
           <div className='text-center mb-2'><MDBBtn color="info" onClick={this.toggle}><MDBIcon icon="plus-square" />  เพิ่มบทความสัมมนา</MDBBtn></div> 

            <MDBModal isOpen={this.state.modal} toggle={this.toggle} size="lg">
              <MDBModalHeader toggle={this.toggle}>เพิ่มบทความสัมมนา</MDBModalHeader>
              <form 
                onSubmit={this.handleSubmit}
                 >
              <MDBModalBody>
              <img src={ban} className="rounded mx-auto " alt="aligment" />
          
              <div>
              <br/>
           
                         

                            <div className="mb-2">
                            <label><strong>กลุ่มเนื้อหาการนำเสนอ</strong></label> <label className="red-text">*</label>
                            <select className="browser-default custom-select" onChange={this.handleChangetype} required>
                            <option value="" >---เลือกกลุ่มเนื้อหาการนำเสนอ---</option>
                            {items}
                                        {/* <option>------กรุณาเลือกประเภทนำเสนอ------</option>
                                         <option value="1" >นำเสนอแบบปากเปล่า</option>
                                         <option value="2" >นำเสนอแบบโปสเตอร์</option> */}
                            </select>
                            </div>

                            <div className="mb-2">
                            <label><strong>ผู้นำเสนอ (จะแสดงในเกียรติบัตร ตัวอย่าง : ชื่อที่1 ชื่อที่2 และชื่อที่3) </strong></label> <label className="red-text">*</label>
                           <input className="form-control" onChange={this.handleChangenamepresent} name="name"
                                    value={this.state.namepresent} placeholder="กรุณาระบุผู้นำเสนอ" required />
                            </div>
                  

                           <div className="mb-2">
                           <label><strong>หัวข้อบทความสัมมนา</strong></label> <label className="red-text">*</label>
                           <input className="form-control" onChange={this.handleChangesend_name} name="name"
                                    value={this.state.send_name} placeholder="กรุณาระบุหัวข้อบทความ" required />
                            </div>


                            <div className="mb-2">
                            <label><strong>อัพโหลดไฟล์บทความ <MDBIcon icon="file-word" /> .docx</strong></label> 
                                {/* <MDBInput  icon="file-upload" group   type="file" validate error="wrong"
                                 success="right"  name="file" value={this.state.value} onChange={this.handleChange3}/> */}
                                  <input
                                        type="file"
                                        name="file" value={this.state.value} onChange={this.handleChange1}
                                        className="form-control"
                                        id="formGroupExampleInput"
                                        accept="application/msword,*,.doc, .docx"
                                        
                                    />
                            </div>

                            <div className="mb-2">
                            <label><strong>อัพโหลดไฟล์บทความ <MDBIcon icon="file-pdf" /> .pdf</strong></label> <label className="red-text">*</label>
                                {/* <MDBInput  icon="file-upload" group   type="file" validate error="wrong"
                                 success="right"  name="file" value={this.state.value} onChange={this.handleChange3}/> */}
                                  <input
                                        type="file"
                                        name="file" value={this.state.value} onChange={this.handleChange2}
                                        className="form-control"
                                        id="formGroupExampleInput"
                                        accept="application/pdf,*"
                                        required
                                    />
                            </div>

                            {/* <div className="text-center form-group ">
             <MDBFormInline >
             <MDBInput
          gap
          onClick={this.onClickradio(1)}
          checked={this.state.radio === 1 ? true : false}
          label="ท่านยืนยันว่าบทความนี้ไม่ได้มีการตีพิมพ์เผยแพร่ที่ไหนมาก่อน "
          type="radio"
          id="radio1"
          containerClass="mr-5"
        />
         </MDBFormInline>
             </div> */}

                            {/* <div className="mb-2">
                            <label><strong>อัพโหลดไฟล์รับรองบทความ <MDBIcon icon="file-word" /> .docx</strong></label>
                              
                                  <input
                                        type="file"
                                        name="file" value={this.state.value} onChange={this.handleChange3}
                                        className="form-control"
                                        id="formGroupExampleInput"
                                        accept="application/msword,*,.doc, .docx"
                                    />
                            </div>

                            <div className="mb-2">
                            <label><strong>อัพโหลดไฟล์รับรองบทความ <MDBIcon icon="file-pdf" /> .pdf</strong></label>
                              
                                  <input
                                        type="file"
                                        name="file" value={this.state.value} onChange={this.handleChange4}
                                        className="form-control"
                                        id="formGroupExampleInput"
                                        accept="application/pdf,*"
                                    />
                            </div> */}

                 
              </div>
              
              </MDBModalBody>
              <MDBModalFooter>
                 {/* <MDBBtn color="primary" onClick={this.handleSubmit} >บันทึก</MDBBtn> */}
                 <MDBBtn color="primary" type='submit' >บันทึก</MDBBtn>
                <MDBBtn color="secondary" onClick={this.toggle}>ปิด</MDBBtn>
              </MDBModalFooter>

              </form>
            </MDBModal>
          </MDBContainer>
          
        )
    }
}
